import colors from '../styles/colors';
import { opacityHex } from '../utils/color.utils';
import { css } from 'styled-components';

export const navBarBoxShadow = '0 0 6px 0 rgba(0, 18, 71, 0.08)';
export const blockBoxShadow =
    '0 2px 8px 0 rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.05);';
export const hoverEase = ['0.15s', 'ease'];

export const Z_INDEX = {
    MODAL: 10,
    TOP: 900,
    TOP_MOST: 1000,
    NAVBAR: 2000,
    FULL_SCREEN: 3000,
    LOADER: 10000,
    POPOVER: 20000,
    MENU: 30000,
    TOAST: 1000001,
    SPLASH: 2147483647
};

export const BOX_SHADOW = {
    checkbox: {
        checked: css`
            box-shadow: 0px 2px 5px 0px ${colors.blue50_20};
        `,
        default: css`
            box-shadow: inset 0px 1px 2px ${opacityHex(colors.neutral900, 15)};
        `
    }
} as const;

export const cornerRadiusRound = '999px';
